import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

function Gallery(props) {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openGallery = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <>

      <div className="gallery-wrapper">
        <div
          className="gallery-main"
          onClick={() => openGallery(0)}
        >
          <img src={props.images[0]} alt="" />
        </div>

        <div className="gallery-side">
          <div
            className="gallery-small"
            onClick={() => openGallery(1)}
          >
            <img src={props.images[1]} alt="" />
          </div>

          <div
            className="gallery-small"
            onClick={() => openGallery(2)}
          >
            <img src={props.images[2]} alt="" />
          </div>
        </div>
      </div>
      
      {props.images.length > 3 ?
        <button
          className="view-all-btn"
          onClick={() => openGallery(3)}
        >
          + {props.images.length - 3}
        </button> : null}


      {isOpen && (
        <Lightbox
          mainSrc={props.images[photoIndex]}
          nextSrc={props.images[(photoIndex + 1) % props.images.length]}
          imageTitle={`${photoIndex + 1} / ${props.images.length}`}
          prevSrc={
            props.images[
            (photoIndex + props.images.length - 1) % props.images.length
            ]
          }
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + props.images.length - 1) % props.images.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex(
              (photoIndex + 1) % props.images.length
            )
          }
        />
      )}
    </>
  );
}

export default Gallery;